/*
 * 위키 연결을 맺는 중인지 (가벼운 모듈: 알림 연결이 이것을 보려고 위키 묶음을 불러오지 않게).
 * 브라우저는 같은 주소의 WebSocket을 하나씩 맺으므로, 위키 페이지로 처음 열 때는 알림 연결이 위키 연결 뒤에 서게 한다 (편집을 먼저 할 수 있게).
 */
let state: "idle" | "connecting" | "settled" = "idle";
const waiters: (() => void)[] = [];

export function setCollabConnecting(connecting: boolean) {
  if (connecting) {
    if (state === "idle") state = "connecting";
    return;
  }
  state = "settled";
  for (const done of waiters.splice(0)) done();
}

/** 위키 페이지 주소 (/wiki/12, /c/3/wiki/12) */
export const isWikiPagePath = (path: string) => /^\/(c\/\d+\/)?wiki\/\d+/.test(path);

/**
 * 위키 연결이 맺어질 때까지(최대 timeoutMs) 기다린다. 맺는 중이 아니면 바로.
 * expected: 곧 맺을 것이다 (위키 페이지로 열었는데 화면이 아직 연결을 시작하지 않았을 수 있다)
 */
export function afterCollabConnects(timeoutMs: number, expected = false): Promise<void> {
  if (state === "settled" || (state === "idle" && !expected)) return Promise.resolve();
  return new Promise((resolve) => {
    waiters.push(resolve);
    setTimeout(resolve, timeoutMs);
  });
}
